import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { authIdxReload } from 'redux/action/login';
import { dispensingModuleManager, moduleManager } from 'redux/action/modules';
import moment from 'moment';
import { SHA256 } from 'utils/SHA256';
import { delay } from 'utils/utils';
import Popup from 'popup/Popup';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import { UserEditablePopupContainer } from './UserEditablePopup.css.js';

const UserEditablePopup = ({ user, dataReloadFunc, auths, children }) => {
  const history = useHistory();
  const [authLevel, setAuthLevel] = useState(1);
  const [smsFlag, setSmsFlag] = useState(0);
  const [checker, setChecker] = useState(true);
  const [telNum, setTelNum] = useState()
  const { register, handleSubmit, setValue, errors, clearErrors } = useForm();
  const dispatch = useDispatch();
  const [popupOpen, setPopupOpen] = useState(null);

  useEffect(() => {
    if (user) {
      const auth = auths.find((x) => x.authIdx === user.authIdx);
      if (auth !== undefined) {
        setAuthLevel(auth.level);
      }
    }
  }, [user, auths]);

  useEffect(() => {
    setValue('smsFlag', smsFlag);
  }, [smsFlag, setValue]);

  const confirmModule = useCallback(
    (data) => {
      if (!checker) {
        return false;
      }

      setChecker(false);

      const [url, msg, encodeUserPw] =
        user.userIdx === null ? ['/api/user/insertData', '등록', SHA256(data.userPw)] : ['/api/user/updateData', '수정', user.userPw];

      customAxiosPostFunction(history, url, { ...data, userIdx: user.userIdx, tel: telNum, userPw: encodeUserPw, smsFlag: smsFlag, rgstDt: moment().format('YYYY-MM-DDTHH:mm:ssZ') })
        .then((response) => {
          if (response !== null && response !== 0) {
            dispatch(authIdxReload());
            delay(2000).then(() => {
              dispatch(dispensingModuleManager(Number(data.authIdx)));
              dispatch(moduleManager(Number(data.authIdx)));
              alert(`${msg}완료`);
              setPopupOpen(false);
              dataReloadFunc();
            });
          } else {
            alert(`${msg}실패`);
          }

          setChecker(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    [user, checker]
  );

  return (
    <Popup
      trigger={children}
      modal
      open={popupOpen}
      onOpen={() => {
        setPopupOpen(true);
      }}
      onClose={() => {
        clearErrors();
      }}
    >
      {user && (
        <form onSubmit={handleSubmit(confirmModule)}>
          <UserEditablePopupContainer checker={checker}>
            <div>
              <div>
                <p>아이디</p>
                <input type="text" name="userId" ref={register({ required: true, maxLength: 20 })} defaultValue={user.userId} />
              </div>
              <div className="error-box">{errors.userId && '올바른 아이디를 입력해주세요'}</div>
            </div>
            <div>
              <div>
                <p>비밀번호</p>
                <input
                  type="password"
                  name="userPw"
                  ref={register({
                    required: true,
                    minLength: 8,
                    maxLength: 15,
                    pattern: /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/,
                  })}
                  defaultValue={user.userPw !== '' ? '11aa*******!!' : ''}
                  readOnly={user.userPw !== ''}
                />
              </div>
              <div className="error-box">{errors.userPw && '비밀번호는 숫자, 영어, 특수문자를 포함한 8~15자리로 입력해주세요'}</div>
            </div>
            <div>
              <div>
                <p>이름</p>
                <input type="text" name="userNm" ref={register({ required: false, maxLength: 10 })} defaultValue={user.userNm} />
              </div>
            </div>
            <div>
              <div>
                <p>연락처</p>
                <input type="text" name="userTel" ref={register({ required: false, maxLength: 18 })} defaultValue={user.userTel} />
              </div>
            </div>
            <div>
              <div>
                <p>수신여부</p>
                <div>
                <select
                  name="smsFlag"
                  ref={register}
                  defaultValue={smsFlag}
                  onChange={({ target }) => setSmsFlag(target.value)}
                >
                  <option value={1}>예</option>
                  <option value={0}>아니오</option>
                </select>

                </div>
              </div>
            </div>
            <div>
              <div>
                <p>권한</p>
                <div>
                  <select
                    defaultValue={authLevel}
                    onChange={({ target }) => {
                      setAuthLevel(Number(target.value));
                    }}
                  >
                    <option value={1}>슈퍼관리자</option>
                    <option value={2}>안전관리자</option>
                    <option value={3}>공장관리자</option>
                    <option value={4}>공장내부관리자</option>
                  </select>
                  <select name="authIdx" ref={register} defaultValue={user.authIdx}>
                    {auths &&
                      auths
                        .filter((auth) => auth.level === authLevel)
                        .map((auth) => {
                          return (
                            <option key={auth.authIdx} value={auth.authIdx}>
                              {auth.authNm}
                            </option>
                          );
                        })}
                  </select>
                </div>
              </div>
            </div>
            <button type="submit">{user.length === 0 ? '등록' : '수정'}</button>
          </UserEditablePopupContainer>
        </form>
      )}
    </Popup>
  );
};

export default UserEditablePopup;
